import React from 'react'
import { BaybayinText } from '@fs/zion-homelands-shared'
import { Button, Card, colors, H3, LayoutBand, Paragraph, Row, Separator } from '@fs/zion-ui'
import { kebabCase } from 'lodash-es'

import SocialShareImage from './SocialShareImage'
import ShareableImage from '../../../../../components/ShareableImage/ShareableImage'
import useShareableImage from '../../../../../components/ShareableImage/useShareableImage'

export default function BaybayinSection({ surname }) {
  const learnMoreUrl = `/philippines/baybayin?name=${encodeURIComponent(surname)}`

  const shareable = useShareableImage({
    width: 786,
    height: 597,
    generateOnLoad: false,
    name: `baybayin-${kebabCase(surname)}`,
    scale: 1.4,
  })

  return (
    <>
      <LayoutBand color={colors.gray02} id="baybayin-section" marginY="xl" marginX="xl">
        <H3 centered supplementary balanced>
          My Surname in Baybayin
        </H3>
        <Separator size="xs" />
        <Paragraph centered>
          Baybayin is an ancient Filipino script that predates Spanish colonization. This beautiful and unique script
          was used to write various Philippine languages.
        </Paragraph>
        <Separator size="sm" />
        <Button
          centered
          color="gray"
          emphasis="medium"
          to={learnMoreUrl}
          external
          linkName="asia-pacific_baybayin-section_learn-more"
        >
          Learn More About Baybayin
        </Button>
        <Separator size="lg" />
        <Card edges="none" backgroundColor="white">
          <BaybayinText text={surname} maxFontSize={120} />
        </Card>
        <Separator size="lg" />
        <Row alignX="center">
          <Button
            color="gray"
            emphasis="medium"
            onClick={async () => {
              await shareable.generateImage()
              await shareable.downloadImage()
            }}
          >
            Download Image
          </Button>
        </Row>
      </LayoutBand>
      <ShareableImage {...shareable}>
        <SocialShareImage surname={surname} variant="baybayin" />
      </ShareableImage>
    </>
  )
}
